
import { Question } from '../types';

export const taj101IntroductionQuestions: Question[] = [
  {
    id: 'taj001',
    text: 'What is the literal meaning of Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'To do something well', isCorrect: true },
      { id: 'b', text: 'To read slowly', isCorrect: false },
      { id: 'c', text: 'To memorize perfectly', isCorrect: false },
      { id: 'd', text: 'To beautify one\'s voice', isCorrect: false }
    ],
    explanation: 'Tajweed literally means "to do something well." Technically, it means to pronounce every letter from its point of origin (makhraj) with all its characteristics (ṣifāt).',
    topic: 'taj101'
  },
  {
    id: 'taj002',
    text: 'What is the technical definition of Tajweed according to the qurrāʾ (reciters)?',
    type: 'single',
    options: [
      { id: 'a', text: 'To pronounce every letter from its makhraj with all its ṣifāt', isCorrect: true },
      { id: 'b', text: 'To recite the Qur\'ān with a beautiful voice', isCorrect: false },
      { id: 'c', text: 'To memorize the Qur\'ān with perfection', isCorrect: false },
      { id: 'd', text: 'To read the Qur\'ān slowly and deliberately', isCorrect: false }
    ],
    explanation: 'Technically, Tajweed according to the qurrāʾ means to pronounce every letter from its point or place of origin (makhraj) together with all its characteristics (ṣifāt).',
    topic: 'taj101'
  },
  {
    id: 'taj003',
    text: 'What is the subject matter of Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'The letters of the Arabic alphabet', isCorrect: true },
      { id: 'b', text: 'The meaning of the Qur\'ān', isCorrect: false },
      { id: 'c', text: 'The history of Qur\'ānic revelation', isCorrect: false },
      { id: 'd', text: 'The compilation of the Qur\'ān', isCorrect: false }
    ],
    explanation: 'In Tajweed, we discuss the letters of the Arabic alphabet - their proper pronunciation, characteristics, and rules governing their recitation.',
    topic: 'taj101'
  },
  {
    id: 'taj004',
    text: 'What is the ruling (ḥukm) regarding learning the rules of Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Farḍ kifāyah (communal obligation)', isCorrect: true },
      { id: 'b', text: 'Farḍ ʿayn (individual obligation)', isCorrect: false },
      { id: 'c', text: 'Sunnah (recommended)', isCorrect: false },
      { id: 'd', text: 'Mubāḥ (permissible)', isCorrect: false }
    ],
    explanation: 'It is farḍ kifāyah to learn all the rules of Tajweed. This means that if at least one person in the community performs it, the responsibility falls away from the rest of society.',
    topic: 'taj101'
  },
  {
    id: 'taj005',
    text: 'What is the ruling (ḥukm) regarding reciting the Qur\'ān with Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Farḍ ʿayn (individual obligation)', isCorrect: true },
      { id: 'b', text: 'Farḍ kifāyah (communal obligation)', isCorrect: false },
      { id: 'c', text: 'Sunnah (recommended)', isCorrect: false },
      { id: 'd', text: 'Mandūb (preferred)', isCorrect: false }
    ],
    explanation: 'It is farḍ ʿayn to recite the Qur\'ān with Tajweed. This means it is required from every individual Muslim to apply the basic rules of Tajweed when reciting the Qur\'ān.',
    topic: 'taj101'
  },
  {
    id: 'taj006',
    text: 'What is the primary benefit of learning Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'To protect ourselves from making mistakes in the recitation of the Qur\'ān', isCorrect: true },
      { id: 'b', text: 'To impress others with beautiful recitation', isCorrect: false },
      { id: 'c', text: 'To win Qur\'ān recitation competitions', isCorrect: false },
      { id: 'd', text: 'To become a professional qāriʾ (reciter)', isCorrect: false }
    ],
    explanation: 'By learning Tajweed, we protect ourselves from making mistakes in the recitation of the Qur\'ān, thus preserving its intended meaning and respecting its sanctity.',
    topic: 'taj101'
  },
  {
    id: 'taj007',
    text: 'What is laḥn jaliyy in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'A clear error that changes the meaning and is apparent to everyone', isCorrect: true },
      { id: 'b', text: 'A hidden error only recognized by Tajweed experts', isCorrect: false },
      { id: 'c', text: 'A minor pronunciation issue that doesn\'t affect meaning', isCorrect: false },
      { id: 'd', text: 'An error in the melody of recitation', isCorrect: false }
    ],
    explanation: 'Laḥn jaliyy (a clear error) is evident to everyone listening, indicating that an error has been made in the recitation. It often alters the meaning of what is being recited.',
    topic: 'taj101'
  },
  {
    id: 'taj008',
    text: 'What is the ruling on reciting the Qur\'ān with laḥn jaliyy (clear error) if one is aware of it and making no effort to correct it?',
    type: 'single',
    options: [
      { id: 'a', text: 'Ḥarām (prohibited)', isCorrect: true },
      { id: 'b', text: 'Makrūh (disliked)', isCorrect: false },
      { id: 'c', text: 'Mubāḥ (permissible)', isCorrect: false },
      { id: 'd', text: 'No specific ruling', isCorrect: false }
    ],
    explanation: 'It is ḥarām (prohibited) to recite the Qur\'ān with laḥn jaliyy when the qāriʾ (reciter) is aware that he is making laḥn jaliyy and is making no effort to correct his recitation.',
    topic: 'taj101'
  },
  {
    id: 'taj009',
    text: 'In how many ways can laḥn jaliyy (clear error) occur?',
    type: 'single',
    options: [
      { id: 'a', text: 'Four ways', isCorrect: true },
      { id: 'b', text: 'Two ways', isCorrect: false },
      { id: 'c', text: 'Six ways', isCorrect: false },
      { id: 'd', text: 'Eight ways', isCorrect: false }
    ],
    explanation: 'Laḥn jaliyy can occur in four ways: adding a letter, omitting a letter, changing a letter, or changing a vowel (ḥarakah).',
    topic: 'taj101'
  },
  {
    id: 'taj010',
    text: 'What is laḥn khafiyy in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'A hidden error related to the temporary characteristics of letters', isCorrect: true },
      { id: 'b', text: 'A clear error that changes the meaning', isCorrect: false },
      { id: 'c', text: 'An error in the sequence of verses', isCorrect: false },
      { id: 'd', text: 'Mispronouncing names in the Qur\'ān', isCorrect: false }
    ],
    explanation: 'Laḥn khafiyy is made when the qāriʾ falters in the temporary characteristics (ṣifāt ʿāriḍah) of the letters, such as ikhfāʾ, madd, etc. It is called "hidden" because the error is obscure to most people and only recognized after studying Tajweed.',
    topic: 'taj101'
  }
];
